var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-8" },
      [
        _c(
          "c-card",
          {
            staticClass: "cardClassDetailForm",
            attrs: { title: "법규별 규제사항" },
          },
          [
            _c("template", { slot: "card-description" }, [
              _c(
                "span",
                { staticStyle: { color: "tomato", "margin-left": "10px" } },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        "주황색 테두리로 강조된 규제 항목은 사용자가 직접 확인을 하여 체크를 하셔야 합니다."
                      ) +
                      " "
                  ),
                ]
              ),
            ]),
            _c(
              "template",
              { slot: "card-button" },
              [
                _c(
                  "q-btn-group",
                  { attrs: { outline: "" } },
                  [
                    _c("c-btn", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editable,
                          expression: "editable",
                        },
                      ],
                      attrs: { label: "이력보기", icon: "restore" },
                      on: { btnClicked: _vm.openHistory },
                    }),
                    _vm.editable
                      ? _c("c-btn", {
                          attrs: {
                            label: "규제항목 기준값 조회",
                            icon: "help",
                          },
                          on: { btnClicked: _vm.openChemQuantity },
                        })
                      : _vm._e(),
                    _vm.editable
                      ? _c("c-btn", {
                          attrs: {
                            url: _vm.saveUrl,
                            isSubmit: _vm.isSave,
                            param: _vm.saveData,
                            mappingType: "PUT",
                            label: "LBLSAVE",
                            icon: "save",
                          },
                          on: {
                            beforeAction: _vm.saveInfo,
                            btnCallback: _vm.saveCallback,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "template",
              { slot: "card-detail" },
              _vm._l(_vm.bills, function (item, idx) {
                return _c(
                  "div",
                  { key: idx, staticClass: "col-12 divchklaw" },
                  [
                    _c("div", { staticClass: "lawspan" }, [
                      _vm._v(_vm._s(item.regulationBillName)),
                    ]),
                    _vm._l(item.reguls, function (regul, _idx) {
                      return _c("q-checkbox", {
                        key: _idx,
                        staticClass: "customqcbox",
                        class: {
                          "highlight-checkbox": _vm.highlightCodes.includes(
                            regul.regulatedItemCd
                          ),
                        },
                        attrs: {
                          dense: "",
                          color: "orange-custom",
                          "true-value": "Y",
                          "false-value": "N",
                          disable: !_vm.editable,
                          label: regul.regulatedItemName,
                        },
                        model: {
                          value: regul.val,
                          callback: function ($$v) {
                            _vm.$set(regul, "val", $$v)
                          },
                          expression: "regul.val",
                        },
                      })
                    }),
                  ],
                  2
                )
              }),
              0
            ),
          ],
          2
        ),
        _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4" },
      [
        _c(
          "c-card",
          {
            staticClass: "cardClassDetailForm",
            attrs: { title: "규제 선택 참고사항" },
          },
          [
            _c("template", { slot: "card-detail" }, [
              _c("div", { staticClass: "cardContents" }, [
                _c("ul", [
                  _c("li", [
                    _c("div", { staticClass: "law-title" }, [
                      _vm._v("1. 산업안전보건법"),
                    ]),
                    _c("div", { staticClass: "law-desc" }, [
                      _vm._v(" 📌 "),
                      _c("b", [_vm._v("[제조금지/허가/관리대상 등]")]),
                      _vm._v("은 "),
                      _c("b", [_vm._v("함유량(%)")]),
                      _vm._v(" 기준을 만족해야 합니다."),
                      _c("br"),
                      _vm._v(" 📌 "),
                      _c("b", [_vm._v("[노출기준/허용기준]")]),
                      _vm._v("은 "),
                      _c("b", [_vm._v("TWA/STEL")]),
                      _vm._v(" 노출 농도를 기준으로 합니다."),
                      _c("br"),
                      _vm._v(" 📌 "),
                      _c("b", [_vm._v("[PSM 대상물질]")]),
                      _vm._v("은 제조/취급/저장 "),
                      _c("b", [_vm._v("일일 규정수량")]),
                      _vm._v("을 기준으로 합니다. "),
                    ]),
                  ]),
                  _c("li", [
                    _c("div", { staticClass: "law-title" }, [
                      _vm._v("2. 화학물질관리법"),
                    ]),
                    _c("div", { staticClass: "law-desc" }, [
                      _vm._v(" 📌 "),
                      _c("b", [_vm._v("[제한/금지물질]")]),
                      _vm._v("은 "),
                      _c("b", [_vm._v("함유량(%)")]),
                      _vm._v(" 기준을 따릅니다."),
                      _c("br"),
                      _vm._v(" 📌 "),
                      _c("b", [_vm._v("[사고대비/유독물질(급성 등)]")]),
                      _vm._v("은 "),
                      _c("b", [_vm._v("함유량과 규정수량")]),
                      _vm._v("을 모두 확인해야 합니다."),
                      _c("br"),
                      _vm._v(" 📌 "),
                      _c("b", [_vm._v("[PRTR 그룹]")]),
                      _vm._v("은 "),
                      _c("b", [_vm._v("함유량과 연간 취급량")]),
                      _vm._v(" 기준에 따라 체크됩니다. "),
                    ]),
                  ]),
                  _c("li", [
                    _c("div", { staticClass: "law-title" }, [
                      _vm._v("3. 위험물안전관리법"),
                    ]),
                    _c("div", { staticClass: "law-desc" }, [
                      _vm._v(" 📌 "),
                      _c("b", [_vm._v("[제1류 ~ 제6류]")]),
                      _vm._v(
                        "는 물질별 총 허가배수를 직접 확인하여 체크 바랍니다."
                      ),
                      _c("br"),
                      _vm._v(" 📌 "),
                      _c("b", [_vm._v("[제4류, 제5류]")]),
                      _vm._v(
                        "는 수용성/비수용성 여부에 따라 기준값이 달라지므로 주의 바랍니다. "
                      ),
                    ]),
                  ]),
                  _c("li", [
                    _c("div", { staticClass: "law-title" }, [
                      _vm._v("4. 폐기물관리법"),
                    ]),
                    _c("div", { staticClass: "law-desc" }, [
                      _vm._v(" 📌 "),
                      _c("b", [_vm._v("[폐유기용제/지정폐기물]")]),
                      _vm._v("은 함유량 및 성상 기준에 따라 체크합니다. "),
                    ]),
                  ]),
                  _c("li", [
                    _c("div", { staticClass: "law-title" }, [
                      _vm._v("5. 기타 환경 법령 (정량값 없음)"),
                    ]),
                    _c("div", { staticClass: "law-desc" }, [
                      _vm._v(" 📌 "),
                      _c("b", [
                        _vm._v("[고압가스, 대기, 수질, 토양, 악취, 오존 등]"),
                      ]),
                      _vm._v("은 별도의 정량값 입력 없이, 해당 물질이 "),
                      _c("b", [_vm._v("규제 목록에 등재되어 있는지")]),
                      _vm._v(" 여부만 확인하여 체크합니다. "),
                    ]),
                  ]),
                  _c("li", [
                    _c("div", { staticClass: "law-title" }, [
                      _vm._v("※ 주의사항"),
                    ]),
                    _c("div", { staticClass: "law-desc" }, [
                      _vm._v(" 📌 "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "tomato",
                            "font-weight": "bold",
                          },
                        },
                        [_vm._v("주황색 테두리")]
                      ),
                      _vm._v(
                        "로 강조된 항목은 시스템 자동 판단이 어려울 수 있으므로, 사용자가 반드시 규제 여부를 직접 확인해야 합니다. "
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }